var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaferCityMakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 47,
    viewBox: "0 0 34 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0004 17.4822C34.0004 27.1374 26.5448 46.5 17.3479 46.5C8.15091 46.5 0.695312 27.1374 0.695312 17.4822C0.695312 7.82705 8.15091 0 17.3479 0C26.5448 0 34.0004 7.82705 34.0004 17.4822Z",
    fill: "#9AC6E9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3474,
    cy: 17.4823,
    rx: 13.322,
    ry: 13.9858,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaferCityMakerIcon);
export default __webpack_public_path__ + "static/media/Safer_City_Maker_Icon.3ce4999c7f0f6a78a730f6cba7505c41.svg";
export { ForwardRef as ReactComponent };